import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SubmitAiInsightsFeedback, TrackAIEngagementEvent } from './borrower-insights.actions';
import { catchError, of } from 'rxjs';

import { BorrowerInsightsService } from 'app/services/ai/borrower-state/borrower-insights/borrower-insights.service';
import { Injectable } from '@angular/core';
import { NeedsAndConcernsState } from './needs-and-concerns';
import { SuggestedResponsesState } from './suggested-responses';

export interface BorrowerInsightsStateModel {
    borrowerId?: number;
    lastUpdated?: Date;
}

export interface AiInsightsFeedback {
    feedback: 'positive' | 'negative';
    roleSelection?: string;
    additionalFeedbackSelection?: string;
    additionalFeedbackText?: string;
}

@State<BorrowerInsightsStateModel>({
    name: 'borrowerInsights',
    defaults: {
        borrowerId: undefined,
        lastUpdated: undefined,
    },
    children: [
        NeedsAndConcernsState,
        SuggestedResponsesState],
})
@Injectable()
export class BorrowerInsightsState {
    @Selector()
    static borrowerId(state: BorrowerInsightsStateModel) {
        return state?.borrowerId ?? null;
    }

    @Selector()
    static lastUpdated(state: BorrowerInsightsStateModel) {
        return state?.lastUpdated ?? null;
    }

    constructor(private borrowerInsightsService: BorrowerInsightsService) { }

    @Action(SubmitAiInsightsFeedback)
    submitAiInsightsFeedback(
        _ctx: StateContext<BorrowerInsightsStateModel>,
        { borrowerId, componentName, feedbackPayload, correlationId, callSummaryId }: SubmitAiInsightsFeedback
    ) {
        return this.borrowerInsightsService
            .submitAiInsightsFeedback(borrowerId, componentName, feedbackPayload, correlationId, callSummaryId)
            .pipe(catchError(() => of()));
    }

    @Action(TrackAIEngagementEvent)
    trackAIEngagementEvent(
        _ctx: StateContext<BorrowerInsightsStateModel>,
        { borrowerId, componentName, eventType, correlationId, data }: TrackAIEngagementEvent
    ) {
        // Fire and forget, don't wait for the result
        this.borrowerInsightsService
            .trackAIEngagementEvent(borrowerId, componentName, eventType, correlationId, data)
            .pipe(
                catchError((error) => {
                    console.error('AI engagement tracking failed.', {
                        borrowerId,
                        componentName,
                        eventType,
                        error: error.message || error,
                    });
                    return of(null);
                })
            )
            // Execute immediately, don't wait`
            .subscribe();
    }
}
